var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as Artist from './Artist';
import * as SearchResultArtist from './SearchResultArtist';
import * as EventArtist from './EventArtist';
import * as EventArtistRider from './EventArtistRider';
export const ARTIST_FIELDS = gql `
  fragment ArtistFields on Artist {
    id
    name
    bio
    links {
      id
      url
    }
  }
`;
export const ARTIST_SEARCH_QUERY = gql `
  query ArtistSearch($search: String) {
    app {
      artists(search: $search) {
        id
        name
        imageUrl
        soundchartsUuid
      }
    }
  }
`;
export const ARTIST_QUERY = gql `
  query Artist($id: Int!) {
    app {
      artist(id: $id) {
        ...ArtistFields
      }
    }
  }
  ${ARTIST_FIELDS}
`;
export const searchArtists = (client, query) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: ARTIST_SEARCH_QUERY,
        variables: {
            search: query,
        },
    });
    return SearchResultArtist.fromGqlCollection(data.app.artists);
});
export const fetchArtist = (client, id) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: ARTIST_QUERY,
        variables: {
            id,
        },
    });
    return Artist.fromGql(data.app.artist);
});
export const saveArtist = (client, artist) => __awaiter(void 0, void 0, void 0, function* () {
    const mutation = gql `
    mutation SaveArtist($artist: ArtistInput!) {
      app {
        saveArtist(input: { artist: $artist }) {
          artist {
            ...ArtistFields
          }
          errors
        }
      }
    }
    ${ARTIST_FIELDS}
  `;
    yield client.mutate({
        mutation,
        variables: {
            artist,
        },
    });
});
const ADD_EVENT_ARTISTS_MUTATION = gql `
  mutation AddEventArtist($eventId: Int!, $artist: ArtistInput!) {
    app {
      addEventArtist(input: { eventId: $eventId, artist: $artist}) {
        eventArtist {
          id
          artist {
            ...ArtistFields
          }
        }
        clientMutationId
        errors
        success
      }
    }
  }
  ${ARTIST_FIELDS}
`;
export const addEventArtist = (client, addParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: ADD_EVENT_ARTISTS_MUTATION,
        variables: Object.assign({}, addParams),
        update: cache => {
            cache.evict({
                id: 'ROOT_QUERY',
                // Probably needs better cache clearing
                fieldName: 'app',
            });
            cache.gc();
        },
    });
    const response = data.app.addEventArtist;
    if (response.success) {
        return {
            success: true,
            data: EventArtist.fromGql(response.eventArtist),
        };
    }
    return {
        success: false,
        errors: response.errors,
    };
});
const REMOVE_EVENT_ARTIST_MUTATION = gql `
  mutation RemoveEventArtist($eventArtistId: Int!) {
    app {
      removeEventArtist(input: { eventArtistId: $eventArtistId}) {
        clientMutationId
        errors
        success
      }
    }
  }
`;
export const removeEventArtist = (client, removeParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: REMOVE_EVENT_ARTIST_MUTATION,
        variables: Object.assign({}, removeParams),
        update: cache => {
            cache.evict({
                id: 'ROOT_QUERY',
                // Probably needs better cache clearing
                fieldName: 'app',
            });
            cache.gc();
        },
    });
    const response = data.app.removeEventArtist;
    if (response.success) {
        return {
            success: true,
        };
    }
    return {
        success: false,
        errors: response.errors,
    };
});
const REORDER_EVENT_ARTISTS_MUTATION = gql `
  mutation ReorderEventArtists($eventId: Int!, $eventArtistIds: [Int!]!) {
    app {
      reorderEventArtists(input: { eventId: $eventId, eventArtistIds: $eventArtistIds }) {
        success
        eventArtists {
          id
          artist {
            ...ArtistFields
          }
        }
      }
    }
  }
  ${ARTIST_FIELDS}
`;
export const reorderEventArtists = (client, reorderParams) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.mutate({
        mutation: REORDER_EVENT_ARTISTS_MUTATION,
        variables: Object.assign({}, reorderParams),
        update: cache => {
            cache.evict({
                id: 'ROOT_QUERY',
                // Probably needs better cache clearing
                fieldName: 'app',
            });
            cache.gc();
        },
    });
    const response = data.app.reorderEventArtists;
    if (response.success) {
        return {
            success: true,
            data: EventArtist.fromGqlCollection(response.eventArtists),
        };
    }
    return {
        success: false,
    };
});
const EVENT_ARTIST_RIDERS_QUERY = gql `
  query GetEventArtistRiders($eventId: Int!, $artistId: Int) {
    event(id: $eventId) {
      eventArtists(artistId: $artistId) {
        id
        artist {
          id
          name
        }
        riders {
          id
          notes
          riderType
          artistLoadInTime
          stageSoundCheckTime
          soundCheckType
          stagePerformersNumber
          backstagePassesNumber
          attachments {
            id
            name
            mime
            url
            status
          }
        }
      }
    }
  }
`;
export const fetchEventArtistRiders = (client, params) => __awaiter(void 0, void 0, void 0, function* () {
    const { data } = yield client.query({
        query: EVENT_ARTIST_RIDERS_QUERY,
        variables: Object.assign({}, params),
    });
    return EventArtist.fromGqlCollection(data.event.eventArtists);
});
const SAVE_EVENT_ARTIST_RIDER_MUTATION = gql `
  mutation SaveEventArtistRider($eventId: Int!, $artistId: Int!, $rider: EventArtistRiderInput!) {
    app {
      saveEventArtistRider(input: { eventId: $eventId, artistId: $artistId , rider: $rider }) {
        rider {
          id
          notes
          riderType
          artistLoadInTime
          stageSoundCheckTime
          soundCheckType
          stagePerformersNumber
          backstagePassesNumber
          attachments {
            id
            name
            mime
            url
            status
          }
        }
        errors
        success
      }
    }
  }
`;
export const saveEventArtistRider = (client_1, _a) => __awaiter(void 0, [client_1, _a], void 0, function* (client, { eventId, artistId, rider }) {
    const { data } = yield client.mutate({
        mutation: SAVE_EVENT_ARTIST_RIDER_MUTATION,
        variables: {
            eventId,
            artistId,
            rider,
        },
        update: cache => {
            cache.evict({
                id: 'ROOT_QUERY',
                // Probably needs better cache clearing
                fieldName: 'app',
            });
            cache.gc();
        },
    });
    const response = data.app.saveEventArtistRider;
    if (response.success) {
        return {
            success: true,
            data: EventArtistRider.fromGql(response.rider),
        };
    }
    return {
        success: false,
        errors: response.errors,
    };
});
//# sourceMappingURL=Api.js.map